import { getPipingAnomalyClassOptions } from "../../../../utils/data";
import { AnomalySummary, ChecklistItem, FVIPDOChecklistItem, NewAnomalyItem } from "../../../../utils/models";
import { PIPING_LOCATION_OPTIONS } from "../existing-piping-item";
import { matchPhrases } from "../../../../utils/utilities";

import useMappedAnomalies from "../../../../hooks/useMappedAnomalies";

import AccordionItem from "../accordion-item";
import Conditional from "../../../common/conditional";
import CustomAnomalyItems from "../../custom-general/custom-anomaly-items";
import ChecklistForm from "../checklist/checklistItem";
import FVIPDOChecklistForm from "../visual-inspection-pdo/fvi-pdo-checklist-form";
import PipingAnomalySummary from "../../../forms/custom-fvi/pipingAnomalySummary";

interface Props {
    lineId: number;
    isChecklistVisible: boolean;
    isNewFormat: boolean;
    isPDOFormat: boolean;
    lineNumber: string;
    hasAnomalies: 'yes' | 'no';
    additionalComment: string;
    nextAnomalyID: number;
    anomalySummary: AnomalySummary;
    anomalyItems: NewAnomalyItem[];
    checklistItems: ChecklistItem[];
    pdoChecklistItems: FVIPDOChecklistItem[];
    onChangePDOChecklistItems: (items: FVIPDOChecklistItem[]) => void;
    onChangeSummary: (summary: AnomalySummary) => void;
    onChangeAnomalies: (anomalies: NewAnomalyItem[]) => void;
    onChangeAdditionalComment: (comment: string) => void;
    onChangeChecklistItems: (items: ChecklistItem[]) => void;
}

const PipingOverview: React.FC<Props> = ({ additionalComment, anomalySummary, anomalyItems, checklistItems, lineId, lineNumber, nextAnomalyID, hasAnomalies, isPDOFormat, isChecklistVisible, isNewFormat, pdoChecklistItems, onChangePDOChecklistItems, onChangeAnomalies, onChangeSummary, onChangeAdditionalComment, onChangeChecklistItems}) => {
    const mappedAnomalyItems = useMappedAnomalies([{ id: lineId, anomalyItems }]);

    return (
        <>
            <Conditional isVisible={isChecklistVisible}>
                <AccordionItem isActive title="Checklist Items">
                    <ChecklistForm
                        enableChecklistItemComment={false}
                        label="Line Number"
                        anomalyItems={mappedAnomalyItems}
                        items={checklistItems}
                        lineNumber={lineNumber}
                        additionalComment={additionalComment}
                        onAddComment={onChangeAdditionalComment}
                        onItemChange={onChangeChecklistItems}
                    />
                </AccordionItem>
            </Conditional>

            {pdoChecklistItems && (
                <AccordionItem isActive title="Potential Drop Object Checklist">
                    <FVIPDOChecklistForm
                        hasPDO={isPDOFormat}
                        label="Line Number"
                        value={lineNumber}
                        items={pdoChecklistItems}
                        onChangeItems={(items) => onChangePDOChecklistItems(items)}
                    />
                </AccordionItem>
            )}

            <Conditional isVisible={matchPhrases(hasAnomalies, "yes")}>
                <AccordionItem isActive title="Anomaly Items">
                    <CustomAnomalyItems
                        isPDOFormat={isPDOFormat}
                        nextAnomalyID={nextAnomalyID}
                        locationOptions={PIPING_LOCATION_OPTIONS}
                        isNewFormat={isNewFormat}
                        damageClasses={getPipingAnomalyClassOptions()}
                        items={anomalyItems}
                        onDataChange={onChangeAnomalies}
                    />
                </AccordionItem>
            </Conditional>

            <AccordionItem isActive	title="Anomaly Summary & Description">
                <PipingAnomalySummary
                    useNewFormat={isNewFormat}
                    hasAnomalies={hasAnomalies}
                    initialAnomalySummary={anomalySummary} 
                    onAdd={onChangeSummary}
                />
            </AccordionItem>
        </>
    );
};

export default PipingOverview;